import { lazy } from "react";
export { TEST_PATH } from "./path";
export { ToTest } from "./to-test";
export const TestPage = lazy(() => import("./page"));
